import { render } from "./FilesTab.vue?vue&type=template&id=48409c5d&scoped=true"
import script from "./FilesTab.vue?vue&type=script&lang=js"
export * from "./FilesTab.vue?vue&type=script&lang=js"

import "./FilesTab.vue?vue&type=style&index=0&id=48409c5d&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48409c5d"]])

export default __exports__